import { app } from '@ekuaibao/whispered';
import Logger from '.';
export default function initLogger() {
    if (!window.HSM)
        return;
    app.logger = new Logger();
    app.logger.logInstance = window.HSM.datafluxLogs;
}
